import React from 'react';

const MiniCamera = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <path stroke="#224251" strokeLinejoin="round" d="m2.5 6.5.03-1c0-.52.45-1 .97-1h.94c.56 0 1.06.48 1.06 1v1" />
    <path
      stroke="#224251"
      strokeLinejoin="round"
      d="m19.5 6.5-1-2c-.35-.53-.87-1-1.5-1h-5c-.63 0-1.15.47-1.5 1L9 6.5H2.5c-1.5 0-2 .68-2 1.72v10.39c0 1.04.5 1.89 2.06 1.89h18.88c1.56 0 2.06-.85 2.06-1.89V8.22c0-1.04-.5-1.72-2.06-1.72H19.5Z"
    />
    <path stroke="#224251" strokeLinejoin="round" d="M14.5 18.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z" />
    <path
      stroke="#224251"
      strokeLinejoin="round"
      d="M14.5 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM4 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
    />
  </svg>
);

export default MiniCamera;
